export enum AnalyzerChartType {
    PL,
    Delta,
    Gamma,
    Vega,
    Theta,
    Rho
}
